





import { Component, Prop, Vue } from 'vue-property-decorator';

// TODO document2
import { Page } from '@/model/document2/page/page'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Rectangle } from '@/utilityModels/rectangle'

import * as def from '@/definitions'
import { UnitHelper } from '@/helper/unitHelper';
import { DebugHelper } from "@/helper/debugHelper";

@Component({
    components: {
    }
})
export default class DesignController extends Vue 
{
    @Prop() private documentRotate! : number;
    @Prop() private isReverseSurface! : boolean
    @Prop() private page! : Page;
    @Prop() private designPosition! : number;

    private getDesignRect()
    {
        return this.page.getSurface(this.isReverseSurface).getDesignRect(this.designPosition);
    }

    private get positionStyle()
    {
        var left = this.getDesignRect().x / this.page.width * 100;
        var top = this.getDesignRect().y / this.page.height * 100;
        var width = this.getDesignRect().width / this.page.width * 100;
        var height = this.getDesignRect().height / this.page.height * 100;
        return {
            position: "absolute",
            left: left + "%",
            top: top + "%",
            width: width + "%",
            height: height + "%",
            cursor: "pointer"
        };
    }

    private get canvasX()
    {
        return UnitHelper.convert(this.getDesignRect().x, "mm", "px");
    }

    private get canvasY()
    {
        return UnitHelper.convert(this.getDesignRect().y, "mm", "px");
    }

    private get canvasWidth()
    {
        return UnitHelper.convert(this.getDesignRect().width, "mm", "px");
    }

    private get canvasHeight()
    {
        return UnitHelper.convert(this.getDesignRect().height, "mm", "px");
    }

    // マウスイベント
    private onClick()
    {
        this.$emit("select", this.designPosition);
    }

    private onDblclick()
    {
        this.$emit("edit", this.designPosition);
    }

    private onContextMenu(event)
    {
        // コンテキストメニューを呼び出す前に、カレントを変更する
        this.$emit("select", this.designPosition);
        this.$emit("showContextMenu", event);
    }

    private onDragStart(e)
    {
        // FireFoxではsetDataしないとdragendが呼ばれない
        // IEだと例外になるのでtry-catch
        try
        {
            e.dataTransfer.setData('text/plain', 'dummy');
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
        // マウスポインタを移動モードに変更
        e.dataTransfer.effectAllowed = "move";
        // ドラッグ開始イベント
        this.$emit("dragDesignStart", this.designPosition);
    }

    private onDragEnd(e)
    {
        // ドラッグ終了イベント
        this.$emit("dragDesignEnd");
    }
}

